var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('h1',[_vm._v("Registro de correos")]),_c('v-spacer'),_c('Enviar_correo_dialog',{attrs:{"se_envia_a_todos":true}})],1),_c('v-row',[_c('v-list',{staticClass:"transparent"},_vm._l((_vm.correos),function(ref,i){
var correo = ref.correo;
var suscrito_el = ref.suscrito_el;
return _c('v-list-item',{key:i},[_c('Correo_list',{attrs:{"correo":correo,"suscrito_el":suscrito_el}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }